import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';  // ← ADD THIS
import { FluxCard } from '@meltwater/flux-web-components-react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const COLORS = {
	primary: '#18b8b3',
	primaryLight: '#eef9f8',
	primaryBorder: '#bceae7',
	primaryHover: '#0f9b96',
	textPrimary: '#1f2937',
	textSecondary: '#6b7280',
	border: '#e5e7eb',
	white: '#ffffff',
	gray50: '#f9fafb',
	gray100: '#f3f4f6',
	logoBg: '#E8F8F8',
	successBg: '#e1f5ee',
	successText: '#0f6e56',
	errorBg: '#fcebeb',
	errorText: '#a32d2d',
};

// ─── KEEP DUMMY DATA FOR AUDIT (FOR NOW) ──
const AUDIT_DATA = {
	'695ce26dfe826f94350b2bfe': [
		{ date: '2026-06-15', action: 'Entitlement added', user: 'admin@meltwater.com', detail: 'Social Listening Pro' },
		{ date: '2026-05-20', action: 'Override set', user: 'ops@meltwater.com', detail: 'Rate limit increased to 10k/day' },
		{ date: '2026-04-01', action: 'Company created', user: 'admin@meltwater.com', detail: '' },
	],
	'b7e2c51fa304d78209ef6b10': [
		{ date: '2026-06-17', action: 'Override set', user: 'admin@meltwater.com', detail: 'White label enabled' },
		{ date: '2026-06-12', action: 'Entitlement added', user: 'ops@meltwater.com', detail: 'Enterprise Support' },
		{ date: '2026-05-30', action: 'Entitlement added', user: 'ops@meltwater.com', detail: 'Analytics Pro' },
		{ date: '2026-03-15', action: 'Company created', user: 'admin@meltwater.com', detail: '' },
	],
	'a3f1d84bc920e6571cd09a32': [
		{ date: '2026-06-10', action: 'Entitlement added', user: 'admin@meltwater.com', detail: 'API Access' },
		{ date: '2026-05-18', action: 'Company created', user: 'admin@meltwater.com', detail: '' },
	],
};

// SVG icon components
const Icons = {
	building: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 3v18M15 3v18M3 9h18M3 15h18" />
		</svg>
	),
	search: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
		</svg>
	),
	overview: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
		</svg>
	),
	key: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
		</svg>
	),
	overrides: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<circle cx="12" cy="12" r="3" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
		</svg>
	),
	history: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
		</svg>
	),
	hash: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" />
		</svg>
	),
	file: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
		</svg>
	),
	suggestionsOn: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M12 6v6l4 2" />
			<path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
		</svg>
	),
	suggestionsOff: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M12 6v6l4 2" />
			<path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
			<line x1="3" y1="3" x2="21" y2="21" />
		</svg>
	),
};

// Highlight matched substring
const HighlightMatch = ({ text, query }) => {
	if (!query) return <span>{text}</span>;
	const idx = text.toLowerCase().indexOf(query.toLowerCase());
	if (idx === -1) return <span>{text}</span>;
	return (
		<span>
			{text.slice(0, idx)}
			<span style={{ color: COLORS.primary, fontWeight: 600 }}>{text.slice(idx, idx + query.length)}</span>
			{text.slice(idx + query.length)}
		</span>
	);
};

const CompanyManagement = () => {
	const navigate = useNavigate();  // ← ADD THIS
	const location = useLocation();
	const [searchBy, setSearchBy] = useState('companyId');
	const [searchValue, setSearchValue] = useState('');
	const [activeTab, setActiveTab] = useState('overview');
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [notFound, setNotFound] = useState(false);
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);
	const [focusedSuggestion, setFocusedSuggestion] = useState(-1);
	const [validationError, setValidationError] = useState('');
	const [enableSuggestions, setEnableSuggestions] = useState(true);
	const inputRef = useRef(null);
	const suggestionsRef = useRef(null);
	const [, setSelectedSuggestion] = useState(null);

	
	useEffect(() => {
    // Restore from Overrides page navigation (passes full company object)
    if (location.state?.company) {
        setSelectedCompany(location.state.company);
    }
    // Restore from Entitlements page navigation (passes companyId + companyName)
    else if (location.state?.companyId) {
        setSelectedCompany({
            id: location.state.companyId,
            name: location.state.companyName,
            opportunityId: location.state.opportunityId || null,
            country: location.state.country || null,
            buddyAccount: location.state.buddyAccount || null,
            customerId: location.state.customerId || null,
            crmInstanceId: location.state.crmInstanceId || null,
			entitlementCount: location.state.entitlementCount ?? 0,
			overrideCount: location.state.overrideCount ?? 0,
        });
    }
    // Intentionally run only on mount to restore navigation state once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

	// Validation functions
	const validateCompanyId = (value) => {
		const alphanumericRegex = /^[a-zA-Z0-9]+$/;
		if (!alphanumericRegex.test(value)) {
			return 'Company ID must contain only alphanumeric characters';
		}
		if (value.length !== 24) {
			return 'Company ID must be exactly 24 characters';
		}
		return '';
	};

	const validateOpportunityId = (value) => {
    const numericRegex = /^[0-9]+$/;
    if (!numericRegex.test(value)) {
        return 'Opportunity ID must contain only numbers';
    }
    return '';
};
    
    


	const fetchSuggestions = async (val) => {
		console.log("fetchSuggestions called:", val);
		if (!enableSuggestions) return;
		if (!val.trim()) {
			setSuggestions([]);
			setShowSuggestions(false);
			return;
		}
		try {
			const response = await fetch(
				`${BASE_URL}/company/search?name=${encodeURIComponent(val)}`
			);
			const result = await response.json();
			console.log("Suggestions response:", result);
			if (result.status === "ok") {
				const companies = result.data.companies || [];
				setSuggestions(
					companies
						.slice(0, 5)
						.map(company => ({
							id: company._id,
							name: company.name
						}))
				);
				setShowSuggestions(companies.length > 0);
			} else {
				setSuggestions([]);
				setShowSuggestions(false);
			}
		} catch (error) {
			console.error(error);
			setSuggestions([]);
			setShowSuggestions(false);
		}
	};

	const handleInputChange = (e) => {
		let val = e.target.value;
		if (searchBy === 'opportunityId') {
			val = val.replace(/[^0-9]/g, '');
		}
		setSearchValue(val);
		setNotFound(false);
		setValidationError('');
		setSelectedSuggestion(null);
		if (searchBy === 'companyName' && enableSuggestions) {
			fetchSuggestions(val);
		} else {
			setSuggestions([]);
			setShowSuggestions(false);
			if (val.trim()) {
				if (searchBy === 'companyId') {
					const error = validateCompanyId(val);
					setValidationError(error);
				} else if (searchBy === 'opportunityId') {
					const error = validateOpportunityId(val);
					setValidationError(error);
				}
			}
		}
		setFocusedSuggestion(-1);
	};

	const handleKeyDown = (e) => {
		if (!showSuggestions) {
			if (e.key === 'Enter') handleSearch();
			return;
		}
		if (e.key === 'ArrowDown') {
			e.preventDefault();
			setFocusedSuggestion((prev) => Math.min(prev + 1, suggestions.length - 1));
		} else if (e.key === 'ArrowUp') {
			e.preventDefault();
			setFocusedSuggestion((prev) => Math.max(prev - 1, -1));
		} else if (e.key === 'Enter') {
			e.preventDefault();
			if (focusedSuggestion >= 0) {
				setSelectedSuggestion(suggestions[focusedSuggestion]);
				const company = suggestions[focusedSuggestion];
				setSearchValue(company.name);
				setShowSuggestions(false);
				setFocusedSuggestion(-1);
				setValidationError('');
			} else {
				handleSearch();
			}
		} else if (e.key === 'Escape') {
			setShowSuggestions(false);
			setFocusedSuggestion(-1);
		}
	};

	const handleSearch = async () => {
		if (!searchValue.trim()) {
			setValidationError('Please enter a value to search');
			return;
		}
		try {
			const response = await fetch(
				`${BASE_URL}/company/workspace?searchBy=${searchBy}&value=${encodeURIComponent(searchValue)}`
			);
			const result = await response.json();
			console.log("Workspace response:", result);
			if (result.status === "ok") {
				setSelectedCompany({
					id: result.data.companyId,
					name: result.data.companyName,
					opportunityId: result.data.opportunityId,
					country: result.data.country,
					buddyAccount: result.data.buddyAccount,
					customerId: result.data.customerId,
					crmInstanceId: result.data.crmInstanceId,
					entitlementCount: result.data.entitlementCount,
					overrideCount: result.data.overrideCount
				});
				setNotFound(false);
				setValidationError("");
			} else {
				setSelectedCompany(null);
				setNotFound(true);
				setValidationError(
					typeof result.data === "string" ? result.data : result.data.message || "Search failed"
				);
			}
		} catch (error) {
			console.error(error);
			setSelectedCompany(null);
			setNotFound(true);
			setValidationError("Unable to fetch company");
		}
		setShowSuggestions(false);
		setSelectedSuggestion(null);
	};

	const handleClear = () => {
		setSearchBy('companyId');
		setSearchValue('');
		setSelectedCompany(null);
		setNotFound(false);
		setSuggestions([]);
		setShowSuggestions(false);
		setFocusedSuggestion(-1);
		setValidationError('');
		setSelectedSuggestion(null);
	};

	const handleSearchByChange = (e) => {
		const newSearchBy = e.target.value;
		setSearchBy(newSearchBy);
		setSearchValue('');
		setSuggestions([]);
		setShowSuggestions(false);
		setNotFound(false);
		setFocusedSuggestion(-1);
		setValidationError('');
		setSelectedSuggestion(null);
	};

	const toggleSuggestions = () => {
		setEnableSuggestions(!enableSuggestions);
		if (enableSuggestions) {
			setShowSuggestions(false);
			setSuggestions([]);
		}
	};

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (
				inputRef.current &&
				!inputRef.current.contains(e.target) &&
				suggestionsRef.current &&
				!suggestionsRef.current.contains(e.target)
			) {
				setShowSuggestions(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	// ── Sub-components ──────────────────────────────────────────

	const TileButton = ({ icon, label, subtitle, isActive, onClick }) => (
		<button
			onClick={onClick}
			style={{
				display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px',
				padding: '14px 16px',
				background: isActive ? COLORS.primary : COLORS.white,
				border: `1px solid ${isActive ? COLORS.primary : COLORS.border}`,
				borderRadius: '12px', cursor: 'pointer', transition: 'all 0.2s ease',
				flex: 1, textAlign: 'left',
			}}
			onMouseEnter={(e) => { if (!isActive) { e.currentTarget.style.background = COLORS.gray50; e.currentTarget.style.borderColor = '#d1d5db'; } }}
			onMouseLeave={(e) => { if (!isActive) { e.currentTarget.style.background = COLORS.white; e.currentTarget.style.borderColor = COLORS.border; } }}
		>
			<div style={{
				width: '40px', height: '40px', borderRadius: '50%',
				background: isActive ? 'rgba(255,255,255,0.2)' : COLORS.logoBg,
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				color: isActive ? COLORS.white : COLORS.primary, flexShrink: 0,
			}}>
				{icon}
			</div>
			<div>
				<div style={{ fontSize: '14px', fontWeight: 600, color: isActive ? COLORS.white : COLORS.textPrimary, lineHeight: '1.3' }}>
					{label}
				</div>
				{subtitle && (
					<div style={{ fontSize: '12px', color: isActive ? 'rgba(255,255,255,0.75)' : COLORS.textSecondary, marginTop: '2px' }}>
						{subtitle}
					</div>
				)}
			</div>
		</button>
	);

	const StatCard = ({ icon, label, value }) => (
		<FluxCard>
			<div style={{ padding: '18px 20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
				<div style={{
					width: '44px', height: '44px', borderRadius: '50%', background: COLORS.logoBg,
					display: 'flex', alignItems: 'center', justifyContent: 'center',
					color: COLORS.primary, flexShrink: 0,
				}}>
					{icon}
				</div>
				<div>
					<div style={{ fontSize: '12px', fontWeight: 500, color: COLORS.textSecondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
						{label}
					</div>
					<div style={{ marginTop: '4px', fontSize: '22px', fontWeight: 600, color: COLORS.textPrimary }}>
						{value ?? '—'}
					</div>
				</div>
			</div>
		</FluxCard>
	);

	const SectionIcon = ({ icon, size = 36 }) => (
		<div style={{
			width: `${size}px`, height: `${size}px`, borderRadius: '10px', background: COLORS.logoBg,
			display: 'flex', alignItems: 'center', justifyContent: 'center',
			color: COLORS.primary, flexShrink: 0,
		}}>
			{icon}
		</div>
	);

	const ActionButton = ({ onClick, children }) => (
		<button
			onClick={onClick}
			style={{
				background: COLORS.primary, color: COLORS.white, border: 'none',
				padding: '9px 18px', borderRadius: '8px', fontWeight: 500, fontSize: '14px',
				cursor: 'pointer', transition: 'all 0.2s ease',
				display: 'inline-flex', alignItems: 'center', gap: '7px',
			}}
			onMouseEnter={(e) => { e.currentTarget.style.background = COLORS.primaryHover; e.currentTarget.style.transform = 'translateY(-1px)'; }}
			onMouseLeave={(e) => { e.currentTarget.style.background = COLORS.primary; e.currentTarget.style.transform = 'translateY(0)'; }}
		>
			{children}
		</button>
	);

	const EmptyState = ({ icon, title, description }) => (
		<div style={{ padding: '48px 24px', textAlign: 'center', background: COLORS.gray100, borderRadius: '12px' }}>
			<div style={{
				width: '52px', height: '52px', borderRadius: '50%', background: COLORS.logoBg,
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				color: COLORS.primary, margin: '0 auto 14px',
			}}>
				{icon}
			</div>
			<div style={{ fontSize: '15px', fontWeight: 600, color: COLORS.textPrimary, marginBottom: '6px' }}>{title}</div>
			<div style={{ fontSize: '13px', color: COLORS.textSecondary }}>{description}</div>
		</div>
	);

	const TabDivider = () => (
		<div style={{ height: '1px', background: COLORS.border, margin: '24px 0' }} />
	);

	const Badge = ({ valid }) => (
		<span style={{
			display: 'inline-block', padding: '2px 8px', borderRadius: '20px',
			fontSize: '11px', fontWeight: 600, marginLeft: '8px',
			background: valid ? COLORS.successBg : COLORS.errorBg,
			color: valid ? COLORS.successText : COLORS.errorText,
		}}>
			{valid ? '✓ Valid' : 'Not found'}
		</span>
	);

	// ─── NAVIGATE TO ENTITLEMENTS ──────────────────────────────
	const navigateToEntitlements = () => {
    if (selectedCompany) {
        navigate('/entitlements', {
            state: {
                companyId: selectedCompany.id,
                companyName: selectedCompany.name,
                opportunityId: selectedCompany.opportunityId,
                country: selectedCompany.country,
                buddyAccount: selectedCompany.buddyAccount,
                customerId: selectedCompany.customerId,
                crmInstanceId: selectedCompany.crmInstanceId,
                entitlementCount: selectedCompany.entitlementCount,
                overrideCount: selectedCompany.overrideCount,
            }
        });
    }
};

	// ─── NAVIGATE TO OVERRIDES ──────────────────────────────────
	const navigateToOverrides = () => {
		if (selectedCompany) {
			navigate('/overrides', {
				state: { company: selectedCompany },
			});
		}
	};

	// ─── NAVIGATE TO ENTITLEMENT HISTORY ────────────────────────
	const navigateToEntitlementHistory = () => {
		if (selectedCompany) {
			navigate('/companies/history', {
				state: {
					companyId: selectedCompany.id,
					companyName: selectedCompany.name,
					opportunityId: selectedCompany.opportunityId || null,
					country: selectedCompany.country || null,
					buddyAccount: selectedCompany.buddyAccount || null,
					customerId: selectedCompany.customerId || null,
					crmInstanceId: selectedCompany.crmInstanceId || null,
					entitlementCount: selectedCompany.entitlementCount ?? 0,
					overrideCount: selectedCompany.overrideCount ?? 0,
				},
			});
		}
	};

	// ── Tab content renderers ────────────────────────────────────

	const renderOverview = () => {
		const ents = selectedCompany?.entitlementCount || 0;
		const ovrs = selectedCompany?.overrideCount ?? 0;
		return (
			<div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
					<SectionIcon icon={Icons.overview} size={36} />
					<h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Company Overview</h3>
				</div>
				<div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '14px' }}>
					<StatCard icon={Icons.hash} label="Company ID" value={selectedCompany?.id} />
					<StatCard icon={Icons.file} label="Company Name" value={selectedCompany?.name} />
					<StatCard icon={Icons.key} label="Active Entitlements" value={selectedCompany ? String(ents) : undefined} />
					<StatCard icon={Icons.overrides} label="Overrides" value={selectedCompany ? String(ovrs) : undefined} />
					{selectedCompany && (
						<StatCard 
							icon={Icons.hash} 
							label="Opportunity ID" 
							value={selectedCompany.opportunityId || 'No opportunity ID for this account'} 
						/>
					)}
				</div>
			</div>
		);
	};

	// ─── RENDER ENTITLEMENTS (NAVIGATE TO YOUR PAGE) ──────────
	const renderEntitlements = () => {
		return (
			<div>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<SectionIcon icon={Icons.key} size={36} />
						<h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Entitlements</h3>
					</div>
					<ActionButton onClick={navigateToEntitlements}>
						Manage Entitlements →
					</ActionButton>
				</div>
				
				{!selectedCompany ? (
					<EmptyState 
						icon={Icons.key} 
						title="No company selected" 
						description="Search and select a company to manage its entitlements." 
					/>
				) : (
					<div style={{ 
						border: `1px solid ${COLORS.border}`, 
						borderRadius: '12px', 
						padding: '32px',
						textAlign: 'center',
						background: COLORS.gray50
					}}>
						<div style={{ fontSize: '16px', fontWeight: 500, color: COLORS.textPrimary, marginBottom: '8px' }}>
							{selectedCompany.name}
						</div>
						<div style={{ fontSize: '14px', color: COLORS.textSecondary, marginBottom: '16px' }}>
							{selectedCompany.entitlementCount || 0} active entitlements
						</div>
						<ActionButton onClick={navigateToEntitlements}>
							View & Manage Entitlements
						</ActionButton>
					</div>
				)}
			</div>
		);
	};

	const renderOverrides = () => {
		return (
			<div>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<SectionIcon icon={Icons.overrides} size={36} />
						<h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Overrides</h3>
					</div>
					<ActionButton onClick={navigateToOverrides}>
						Manage Overrides →
					</ActionButton>
				</div>
				{!selectedCompany ? (
					<EmptyState icon={Icons.overrides} title="No company selected" description="Search and select a company to view its overrides." />
				) : (
					<div style={{
						border: `1px solid ${COLORS.border}`,
						borderRadius: '12px',
						padding: '32px',
						textAlign: 'center',
						background: COLORS.gray50
					}}>
						<div style={{ fontSize: '16px', fontWeight: 500, color: COLORS.textPrimary, marginBottom: '8px' }}>
							{selectedCompany.name}
						</div>
						<div style={{ fontSize: '14px', color: COLORS.textSecondary, marginBottom: '16px' }}>
							Click below to view and manage all overrides for this company.
						</div>
						<ActionButton onClick={navigateToOverrides}>
							View &amp; Manage Overrides
						</ActionButton>
					</div>
				)}
			</div>
		);
	};

	const renderAudit = () => {
		const logs = selectedCompany ? (AUDIT_DATA[selectedCompany.id] || []) : null;
		return (
			<div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
					<SectionIcon icon={Icons.history} size={36} />
					<h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Audit History</h3>
				</div>
				{!selectedCompany ? (
					<EmptyState icon={Icons.history} title="No company selected" description="Entitlement changes and company modifications will appear here once a company is selected." />
				) : logs && logs.length > 0 ? (
					<div style={{ border: `1px solid ${COLORS.border}`, borderRadius: '12px', overflow: 'hidden' }}>
						{logs.map((l, i) => (
							<div key={i} style={{
								display: 'flex', alignItems: 'flex-start', gap: '14px',
								padding: '13px 18px',
								borderBottom: i < logs.length - 1 ? `1px solid ${COLORS.border}` : 'none',
								background: COLORS.white,
							}}>
								<span style={{ color: COLORS.primary, marginTop: '2px', flexShrink: 0 }}>{Icons.history}</span>
								<div style={{ flex: 1 }}>
									<div style={{ fontSize: '14px', color: COLORS.textPrimary, fontWeight: 500 }}>
										{l.action}
										{l.detail && <span style={{ fontWeight: 400, color: COLORS.textSecondary }}> — {l.detail}</span>}
									</div>
									<div style={{ fontSize: '12px', color: COLORS.textSecondary, marginTop: '3px' }}>
										{l.user} · {l.date}
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<EmptyState icon={Icons.history} title="No activity yet" description="No audit events recorded for this company." />
				)}
			</div>
		);
	};

	// ── Render ───────────────────────────────────────────────────

	const inputPlaceholder =
		searchBy === 'companyId' ? 'Enter Valid Company ID' :
		searchBy === 'companyName' ? 'Enter Valid Company Name' :
		'Enter Valid Opportunity ID';

	const getSuggestionDisplayValue = (company) => {
		if (searchBy === 'companyId') return company.id;
		if (searchBy === 'companyName') return company.name;
		return company.opportunityId || 'No opportunity ID';
	};

	const getSuggestionSecondary = (company) => {
		if (searchBy === 'companyId') return company.name;
		if (searchBy === 'companyName') return company.id;
		return company.name;
	};

	return (
		<div style={{ padding: '32px', maxWidth: '1400px', margin: '0 auto', background: COLORS.gray50, minHeight: '100vh' }}>

			{/* Page Header */}
			<div style={{ marginBottom: '28px' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px' }}>
					<SectionIcon icon={Icons.building} size={40} />
					<h1 style={{ margin: 0, fontSize: '28px', fontWeight: 600, color: COLORS.textPrimary, letterSpacing: '-0.3px' }}>
						Company Workspace
					</h1>
				</div>
				<p style={{ marginLeft: '52px', color: COLORS.textSecondary, fontSize: '14px' }}>
					Manage companies, entitlements, overrides and audit history from one place.
				</p>
				
			</div>

			{/* Search Section */}
			<FluxCard>
				<div style={{ padding: '24px' }}>
					{/* ... (keep search section as is) ... */}
					<div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
						<SectionIcon icon={Icons.search} size={36} />
						<div>
							<h2 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Search Company</h2>
							<div style={{ marginTop: '2px', fontSize: '13px', color: COLORS.textSecondary }}>
								Look up by Company ID, Name, or Opportunity ID
							</div>
						</div>
					</div>

					<div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: '14px', alignItems: 'end' }}>
						<div>
							<label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500, color: COLORS.textSecondary }}>
								Search by
							</label>
							<select
								value={searchBy}
								onChange={handleSearchByChange}
								style={{
									width: '100%', padding: '9px 12px', borderRadius: '8px',
									border: `1px solid ${COLORS.border}`, fontSize: '14px',
									background: COLORS.white, color: COLORS.textPrimary, cursor: 'pointer',
								}}
							>
								<option value='companyId'>Company ID</option>
								<option value='companyName'>Company Name</option>
								<option value='opportunityId'>Opportunity ID</option>
							</select>
						</div>

						<div style={{ position: 'relative' }}>
							<label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: 500, color: COLORS.textSecondary }}>
								Value
							</label>
							<div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
								<input
									ref={inputRef}
									type='text'
									value={searchValue}
									onChange={handleInputChange}
									onKeyDown={handleKeyDown}
									onFocus={() => { if (suggestions.length > 0 && enableSuggestions) setShowSuggestions(true); }}
									placeholder={inputPlaceholder}
									autoComplete='off'
									style={{
										flex: 1,
										padding: '9px 40px 9px 12px',
										borderRadius: '8px',
										border: `1px solid ${validationError ? '#fecaca' : showSuggestions ? COLORS.primary : COLORS.border}`,
										fontSize: '14px', 
										background: COLORS.white, 
										color: COLORS.textPrimary,
										outline: 'none',
										boxShadow: validationError ? `0 0 0 3px #fee2e2` : showSuggestions ? `0 0 0 3px ${COLORS.primaryBorder}` : 'none',
										transition: 'border-color 0.15s, box-shadow 0.15s',
									}}
								/>
								{searchBy === 'companyName' && (
									<button
										onClick={toggleSuggestions}
										style={{
											position: 'absolute',
											right: '8px',
											background: 'none',
											border: 'none',
											cursor: 'pointer',
											color: enableSuggestions ? COLORS.primary : COLORS.textSecondary,
											padding: '4px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											borderRadius: '4px',
											transition: 'all 0.2s ease',
										}}
										onMouseEnter={(e) => { e.currentTarget.style.background = COLORS.gray100; }}
										onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
										title={enableSuggestions ? 'Disable suggestions' : 'Enable suggestions'}
									>
										{enableSuggestions ? Icons.suggestionsOn : Icons.suggestionsOff}
									</button>
								)}
							</div>
							{validationError && (
								<div style={{ fontSize: '12px', color: COLORS.errorText, marginTop: '4px', background: COLORS.errorBg, padding: '4px 8px', borderRadius: '4px' }}>
									{validationError}
								</div>
							)}

							{/* Suggestions dropdown */}
							{showSuggestions && suggestions.length > 0 && (
								<div
									ref={suggestionsRef}
									style={{
										position: 'absolute', 
										top: 'calc(100% + 4px)', 
										left: 0, 
										right: 0,
										background: COLORS.white,
										border: `1px solid ${COLORS.border}`,
										borderRadius: '10px',
										boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
										zIndex: 100, 
										overflow: 'hidden',
										maxHeight: '240px', 
										overflowY: 'auto',
									}}
								>
									{suggestions.map((company, i) => (
										<div
											key={company.id}
											onMouseDown={(e) => { e.preventDefault(); setSearchValue(company.name); setShowSuggestions(false); setSelectedSuggestion(company); setValidationError(''); }}
											onMouseEnter={() => setFocusedSuggestion(i)}
											style={{
												padding: '10px 14px',
												display: 'flex', 
												alignItems: 'center', 
												justifyContent: 'space-between',
												cursor: 'pointer',
												background: focusedSuggestion === i ? COLORS.primaryLight : COLORS.white,
												borderBottom: i < suggestions.length - 1 ? `1px solid ${COLORS.border}` : 'none',
												transition: 'background 0.1s',
											}}
										>
											<span style={{ fontSize: '14px', color: COLORS.textPrimary, flex: 1 }}>
												<HighlightMatch text={getSuggestionDisplayValue(company)} query={searchValue} />
											</span>
											<span style={{ fontSize: '11px', color: COLORS.textSecondary, marginLeft: '12px', background: COLORS.gray100, padding: '2px 8px', borderRadius: '4px' }}>
												{getSuggestionSecondary(company)}
											</span>
										</div>
									))}
									<div style={{ padding: '8px 14px', fontSize: '11px', color: COLORS.textSecondary, borderTop: `1px solid ${COLORS.border}`, background: COLORS.gray50, textAlign: 'center' }}>
										Click a suggestion to fill, then click Search to select
									</div>
								</div>
							)}
						</div>
					</div>

					<div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
						<ActionButton onClick={handleSearch}>Search</ActionButton>
						<button
							onClick={handleClear}
							style={{
								background: COLORS.white, color: COLORS.textSecondary,
								border: `1px solid ${COLORS.border}`, padding: '9px 18px',
								borderRadius: '8px', fontWeight: 500, fontSize: '14px', cursor: 'pointer',
							}}
							onMouseEnter={(e) => { e.currentTarget.style.background = COLORS.gray100; }}
							onMouseLeave={(e) => { e.currentTarget.style.background = COLORS.white; }}
						>
							Clear
						</button>
					</div>
				</div>
			</FluxCard>

			{/* Selected Company Banner */}
			<div style={{ marginTop: '20px' }}>
				<FluxCard>
					<div style={{ padding: '24px' }}>
						{/* ... (keep selected company banner as is) ... */}
						<div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
							<SectionIcon icon={Icons.building} size={36} />
							<h2 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: COLORS.textPrimary }}>Selected Company</h2>
						</div>
						<div style={{
							display: 'flex', alignItems: 'center', gap: '18px', padding: '20px',
							background: notFound ? '#fff5f5' : COLORS.primaryLight,
							borderRadius: '12px',
							border: `1px solid ${notFound ? '#fecaca' : COLORS.primaryBorder}`,
						}}>
							<div style={{
								width: '52px', height: '52px', borderRadius: '50%',
								background: COLORS.white,
								border: `1px solid ${notFound ? '#fecaca' : COLORS.primaryBorder}`,
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								color: notFound ? COLORS.errorText : COLORS.primary, flexShrink: 0,
							}}>
								{Icons.building}
							</div>
							<div>
								<div style={{ fontWeight: 600, fontSize: '15px', color: COLORS.textPrimary, marginBottom: '3px' }}>
									{selectedCompany ? selectedCompany.name : notFound ? `No results for "${searchValue}"` : 'No company selected'}
									{selectedCompany && <Badge valid={true} />}
									{notFound && <Badge valid={false} />}
								</div>
								<div style={{ fontSize: '13px', color: COLORS.textSecondary }}>
									{selectedCompany ? `ID: ${selectedCompany.id} · Opportunity: ${selectedCompany.opportunityId || 'No opportunity ID for this account'} · Switch tabs below to manage.` : notFound ? 'No matching company found. Please check the ID or name and try again.' : 'Search for a company above to view its details, entitlements, overrides and audit history.'}
								</div>
							</div>
						</div>
					</div>
				</FluxCard>
			</div>

			{/* Tabs Section */}
			<div style={{ marginTop: '20px' }}>
				<FluxCard>
					<div style={{ padding: '24px' }}>
						<div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
							<TileButton icon={Icons.overview} label="Overview" subtitle="Company summary" isActive={activeTab === 'overview'} onClick={() => setActiveTab('overview')} />
							<TileButton 
    icon={Icons.key} 
    label="Entitlements" 
    subtitle="Manage access keys" 
    isActive={activeTab === 'entitlements'} 
    onClick={navigateToEntitlements}  // ← Navigates to Entitlements page
/>
							<TileButton icon={Icons.overrides} label="Overrides" subtitle="Custom configurations" isActive={activeTab === 'overrides'} onClick={navigateToOverrides} />
							<TileButton icon={Icons.history} label="Audit History" subtitle="Change log & activity" isActive={activeTab === 'audit'} onClick={navigateToEntitlementHistory} />
						</div>
						<TabDivider />
						{activeTab === 'overview' && renderOverview()}
						{activeTab === 'entitlements' && renderEntitlements()}
						{activeTab === 'overrides' && renderOverrides()}
						{activeTab === 'audit' && renderAudit()}
					</div>
				</FluxCard>
			</div>
		</div>
	);
};

export default CompanyManagement;